/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetOrgInvitesOptions, GetOrgInvitesStatus200, GetOrgInvitesStatus422 } from '../models/GetOrgInvites'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getOrgInvites } from '../clients/axios/getOrgInvites'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getOrgInvitesQueryKey = ({ query }: Omit<GetOrgInvitesOptions, 'headers'> = {}) => [{ url: '/org/invites' }, ...(query ? [query] : [])] as const

type GetOrgInvitesQueryKey = ReturnType<typeof getOrgInvitesQueryKey>

export function getOrgInvitesQueryOptions({ query }: GetOrgInvitesOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getOrgInvitesQueryKey({ query })
  return queryOptions<GetOrgInvitesStatus200, ResponseErrorConfig<GetOrgInvitesStatus422>, GetOrgInvitesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getOrgInvites({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description Get all users invited to the org.
 * @summary Get Org Invites
 * {@link /org/invites}
 */
export function useGetOrgInvites<TData = GetOrgInvitesStatus200, TQueryData = GetOrgInvitesStatus200, TQueryKey extends QueryKey = GetOrgInvitesQueryKey>({ query }: { query?: GetOrgInvitesOptions['query'] | (() => GetOrgInvitesOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<GetOrgInvitesStatus200, ResponseErrorConfig<GetOrgInvitesStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getOrgInvitesQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getOrgInvitesQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOrgInvitesStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
